import axios  from 'axios';
import qs from 'qs';                                        

const instance = axios.create({
  baseURL: process.env.REACT_APP_CAMERA_API,
  timeout: 8000,
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  }
});


export default instance;